/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Psod_Intro_ReloadInputs */

const fr_psod_intro_reload = /** @type {(inputs: Psod_Intro_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En attendant, vous pouvez essayer de recharger l'application.`)
};

const en_psod_intro_reload = /** @type {(inputs: Psod_Intro_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In the meantime, you can try reloading the application.`)
};

/**
* | output |
* | --- |
* | "In the meantime, you can try reloading the application." |
*
* @param {Psod_Intro_ReloadInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const psod_intro_reload = /** @type {((inputs?: Psod_Intro_ReloadInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Psod_Intro_ReloadInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_psod_intro_reload(inputs)
	return en_psod_intro_reload(inputs)
});